import { RejectListingRequestResponse } from 'api/laborerPortalAPI/marketplace'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REJECT_LABORER_LISTING_REQUEST_ASYNC,
    Actions.REJECT_LABORER_LISTING_REQUEST_SUCCESS,
    Actions.REJECT_LABORER_LISTING_REQUEST_FAIL,
    RejectListingRequestResponse
  >,
) => {
  switch (action.type) {
    case Actions.REJECT_LABORER_LISTING_REQUEST_SUCCESS:
    case Actions.REJECT_LABORER_LISTING_REQUEST_ASYNC:
    case Actions.REJECT_LABORER_LISTING_REQUEST_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
